import * as React from 'react'
import { Dispatch, ReactElement, SetStateAction } from 'react'

import { ListSectionHeader, Text } from '@lmc/ui-kit'
import { ConsentFormTemplate } from '@lmc/common/types'
import { find } from 'lodash'
import { getResidentShortCut } from '../utils'
import TextEditor from './TextEditor'
import { colors } from '@lmc/common/constants'
import { Resident } from '@lmc/ts-common'

type ModalConsentFormsProps = {
  copyOfTemplates: ConsentFormTemplate[]
  customForms: ConsentFormTemplate[]
  handleCancelEditForm: (id: string) => void
  handleEditForm: (id: string) => void
  resident: Resident
  setCopyOfTemplates: Dispatch<SetStateAction<any[]>>
  setCustomForms: Dispatch<SetStateAction<any[]>>
  sideControlIds: {
    isSelected: boolean
    title: string
    id: string
  }[]
  templates: any[]
  translate: (key: string, variable?: any) => string
}

export const ModalConsentForms = ({
  copyOfTemplates,
  handleCancelEditForm,
  handleEditForm,
  resident,
  setCopyOfTemplates,
  sideControlIds,
  templates,
  translate,
  customForms,
  setCustomForms,
}: ModalConsentFormsProps): ReactElement => (
  <>
    <ListSectionHeader
      title={`${resident?.preferredName || resident?.name?.first}${translate(
        'consentsTo'
      )}`}
      shortCut={getResidentShortCut(resident)}
      titleIcon={undefined}
    />
    {customForms?.map((item) => {
      const { isCreated } = item
      return (
        <TextEditor
          key={item.id}
          isSelected={isCreated || false}
          item={item}
          resident={resident}
          setCopyOfTemplates={setCustomForms}
          copyOfTemplates={customForms}
          handleCancelEditForm={handleCancelEditForm}
          handleEditForm={handleEditForm}
          customEntry
        />
      )
    })}

    {templates?.map((item) => {
      const isSelected = find(sideControlIds, {
        isSelected: true,
        id: item.id,
      })

      return (
        <TextEditor
          key={item.id}
          isSelected={!!isSelected}
          item={item}
          resident={resident}
          handleCancelEditForm={handleCancelEditForm}
          handleEditForm={handleEditForm}
          setCopyOfTemplates={setCopyOfTemplates}
          copyOfTemplates={copyOfTemplates}
        />
      )
    })}
    {customForms.length === 1 &&
      !find(sideControlIds, {
        isSelected: true,
      }) && (
        <Text style={styles.nothing as React.CSSProperties} as="h4">
          {translate('populateHere')}
        </Text>
      )}
  </>
)

const styles = {
  nothing: {
    textAlign: 'center',
    marginTop: 50,
    color: colors.grey,
  },
}

export default ModalConsentForms
